// extracted by mini-css-extract-plugin
module.exports = {"wage":"wage-form_wage__1grVw"};